<style scoped>
.login-form{
  max-width : 80%;
}
.error-message{
  color : #ff5252;
  font-size : 0.5rem;
}
</style>
<template>
  <v-app>
    <v-toolbar app>
      <v-toolbar-title v-text="'CogStructureBase 1.5'"></v-toolbar-title>
    </v-toolbar>
    <v-container style="position: relative;top: 13%;" class="text-xs-center">
      <v-btn color='info' :href='googleAppURL'> Google Apps でログイン </v-btn>

      <v-container class='login-form'>
        <v-card flat>
          <v-card-title primary-title>
            <h4>Password Login</h4>
          </v-card-title>
          <v-container class='login-form'>
            <p class='error-message' v-for='error in errors'>
            {{error}}
            </p>
            <v-form method="post">
              <input type="hidden" name="csrfmiddlewaretoken" :value="csrfToken">
              <v-text-field prepend-icon="person" name="username" label="Username"></v-text-field>
              <v-text-field prepend-icon="lock" name="password" label="Password" type="password"></v-text-field>
              <v-card-actions>
                <v-btn primary block type=''>
                  <input type="submit" value="Log in" />
                </v-btn>
              </v-card-actions>
            </v-form>
          </v-container>

        </v-card>
      </v-container>
    </v-container>
  </v-app>
</template>
<script>
import Vue from 'vue'

import {
  Vuetify,
  VApp,
  VNavigationDrawer,
  VFooter,
  VList,
  VBtn,
  VIcon,
  VGrid,
  VToolbar,
  VCard,
  VForm,
  VTextField,
  transitions
} from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
import 'material-design-icons/iconfont/material-icons.css'

Vue.use(Vuetify, {
  components: {
    VApp,
    VNavigationDrawer,
    VFooter,
    VList,
    VBtn,
    VIcon,
    VGrid,
    VToolbar,
    transitions,
    VCard,
    VForm,
    VTextField
  },
  theme: {
    primary: '#ee44aa',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.config.productionTip = false

export default {
  props: {
    googleAppURL: {
      required: true,
      type: String
    },
    csrfToken: {
      required: true,
      type: String
    },
    errors: {
      default: [],
      type: Array
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/login.vue